export default {
  TodoType: {
    ClientApproval: {
      label: '用户信息审核',
      value: '1',
    },
    DatalistApproval: {
      label: '材料审核',
      value: '2',
    },
  },
  Status: {
    Pending: {
      label: '待一级审核',
      value: '0',
    },
    FirstPass: {
      label: '待二级审核',
      value: '1',
    },
    Success: {
      label: '审批通过',
      value: '2',
    },
    Obsolete: {
      label: '审核驳回',
      value: '3',
    },
  },
};
